
module.exports = {"attributes":{"width":"34","height":"40"},"content":"<path d=\"M17 40C7.8 40 0 33.2 0 20.2 0 6.6 8.1 0 17.3 0 26.4 0 34 6.5 34 19.9S26.3 40 17 40zm.1-1c4 0 5.2-6.1 5.2-18.7C22.3 7 21 1.1 17.1 1.1c-4 0-5.4 6-5.4 18.7 0 13 1.4 19.1 5.4 19.2z\" />"}
var desvg = require('@kossnocorp/desvg/react')
module.exports = desvg(module.exports)
